import {
  GetPaymentDetailsArgs
} from '@/schemas/payments.schema'
import { useQuery } from '@tanstack/react-query'
import { getPaymentDetail } from '../requests'

export const paymentDetailsKeys = {
  all: ['paymentDetail'] as const,
  detail: (args: GetPaymentDetailsArgs) =>
    [...paymentDetailsKeys.all, args] as const,
}


/**
 * Custom hook for fetching payment details using TanStack Query
 * @param args - The payment ID and program ID
 * @returns Query result with payment details data, loading state, and error
 */
export const usePaymentDetails = (args: GetPaymentDetailsArgs) => {
  const { payment_id, program_id, messages } = args



  return useQuery({
    queryKey: paymentDetailsKeys.detail(args),
    queryFn: () => getPaymentDetail({
      payment_id: payment_id,
      program_id: program_id,
      messages: messages
    }),
    enabled: Number(payment_id) > 0 && Number(program_id) > 0,
  })

}
